
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55.999 55.999"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.125 32.588l-2.85-2.85a2.99 2.99 0 00-4.221 0l-15.39 15.391-2.121 7.779-.519.519a.998.998 0 00-.006 1.405l-.005.02.019-.005a.998.998 0 001.406-.005l.52-.52 7.778-2.121 15.39-15.391a2.988 2.988 0 00-.001-4.222zM34.973 45.649l10.243-10.242 4.243 4.242-10.243 10.243-4.243-4.243zm-.903 1.925l3.22 3.22-4.428 1.208 1.208-4.428zm19.641-12.178l-2.839 2.839-4.243-4.242 2.839-2.839a.987.987 0 011.394-.001l2.85 2.85a.985.985 0 01-.001 1.393zM27 12.865a1 1 0 100 2h18a1 1 0 100-2H27zM46 27.865a1 1 0 00-1-1H27a1 1 0 100 2h18a1 1 0 001-1zM20.58 8.106a.998.998 0 00-1.41.108l-6.248 7.288L9.1 12.636a1.001 1.001 0 00-1.4.2.998.998 0 00.2 1.399l4.571 3.429a.995.995 0 001.36-.15l6.857-8a.998.998 0 00-.108-1.408zM20.58 22.106a.998.998 0 00-1.41.108l-6.248 7.288L9.1 26.636c-.442-.331-1.068-.241-1.4.2s-.242 1.068.2 1.399l4.571 3.429a.995.995 0 001.36-.15l6.857-8a.998.998 0 00-.108-1.408zM19.169 37.214l-6.248 7.287L9.1 41.635c-.442-.331-1.068-.241-1.4.2s-.242 1.068.2 1.399l4.571 3.429a.995.995 0 001.36-.15l6.857-7.999a1 1 0 10-1.519-1.3z"}}),_c('path',{attrs:{"d":"M25 52.865H12.176C6.565 52.865 2 48.3 2 42.689V13.04C2 7.429 6.565 2.865 12.176 2.865h29.648C47.435 2.865 52 7.429 52 13.04v11.824a1 1 0 102 0V13.04C54 6.326 48.538.864 41.824.864H12.176C5.462.865 0 6.326 0 13.04v29.648c0 6.714 5.462 12.176 12.176 12.176H25a1 1 0 100-1.999z"}})])
          )
        }
      }
    